export const markAllAsRead = "D_a";
export const markAsReadNumberOfConversationsWhenCountIsNegative = "E_a";
export const markAsReadNumberOfItemsWhenCountIsNegative = "F_a";
export const markAsReadNumberOfConversations = "G_a";
export const markAsReadNumberOfItems = "H_a";
export default {markAllAsRead,markAsReadNumberOfConversationsWhenCountIsNegative,markAsReadNumberOfItemsWhenCountIsNegative,markAsReadNumberOfConversations,markAsReadNumberOfItems};